<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<p class="first first-in-chapter first-full-width"><i>There was a very long incubation period for this story, which is deeply personal for me in several ways, including my being the parent of a remarkable Down syndrome son. When an editor at </i>Stonecoast Review<i>, Jess Flarity, solicited a story from me for </i>Stonecoast Review <i>#9, I took another, deeper, look at the story and finally realized what it needed and how I could get it done. With the help of Flarity and other editors at </i>Stonecoast<i>, the story clicked for us all. A couple of months later </i>Locus<i> magazine reviewer Rich Horton liked the story well enough to call it a Recommended Read, and then also selected it for inclusion in his annual </i>Best Science Fiction and Fantasy: 2019 <i>anthology (Prime Books, 2019).</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introductiontotodayistoday.vue?c7a4434a